import { useSelector } from 'react-redux';
import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { selectMCBySwitch } from 'shared/slice/masterControlBySwitchSelectSlice';
import { selectMCByLocation } from 'shared/slice/masterControlSelectByLocationSlice';

import {
  flexBoxCenter,
  flexDirectionColumn,
  justifyContentSpaceBetween,
  layerA180Deg,
  layerC,
  layerA,
  readyTop180Deg,
} from 'shared/styles/commonStyles';
import styled, { css } from 'styled-components';

import SelectLocations from './SelectLocations';
import InputTempMessage from 'shared/components/userMessages/inputTempMessage';

import {
  SwitchCardWrapper,
  SwitchCardTitle,
  SwitchSectionTop,
  SwitchFormController,
  SwitchButtonSection,
} from 'features/masterControl/components/shared/styles/switchCardStyles';
import {
  SwitchButtonWrapper,
  SwitchButtonHole,
  SwitchButtonTop,
} from 'features/masterControl/components/shared/styles/controlButtons';

const ShutOff = ({
  scope,
  swtName,
  handleOnClick,
  handleClose,
  isMasterControl,
  specificLocation,
  disabled
}) => {
  const isMobile = useMediaQuery({ query: '(max-width:600px)' });


  const type = scope === 'switch' ? 'locations' : 'switches';

  const switchStatus = useSelector(
    scope === 'switch' ? selectMCBySwitch : selectMCByLocation
  );
  const { selectedOne } = switchStatus.shutOff;


  const [isExpanded, setIsExpanded] = useState(false);
  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [messages, setMessages] = useState([]);

  const handleApply = () => {
    if (!selectedOne) {

      setOpenMessageBox(true);
      setMessages(['select locations', 'please select location to continue']);

      handleOnClick(
        'shutOff',
        'selectA',
        scope,
        '_',
        '_',
        type,
        specificLocation
      );
    } else {
      console.log("handleOnClickXX","shutOff","on",scope)
      handleOnClick('shutOff', 'on', scope);
      if (isMobile && scope !== 'switch') {
        handleClose();
      }
    }
  };

  return (
    <>
      {isMobile ? (
        <>
          {scope === 'switch' ? (
            <MobileWrapper isExpanded={isExpanded}>
              <SectionController
                isMobile={isMobile}
                isMargin={isMobile && isExpanded}
              >
                <MobileHole>
                  <MobileTop>
                    <SectionHeatButton>
                      <HeatButton onClick={handleApply}>m.c off</HeatButton>
                    </SectionHeatButton>

                    <SectionCircle>
                      <CircleButton
                        isExpanded={isExpanded}
                        onClick={() => {
                          setIsExpanded(!isExpanded);
                        }}
                      >
                        <CircleHole>
                          <CircleTop isExpanded={isExpanded}>
                            <LogoImg
                              isSm={true}
                              src={
                                isExpanded
                                  ? '/images/MC-expand-true.svg'
                                  : '/images/MC-expand-false.svg'
                              }
                            />
                          </CircleTop>
                        </CircleHole>
                      </CircleButton>
                    </SectionCircle>
                  </MobileTop>
                </MobileHole>
              </SectionController>

              {isExpanded && (
                <SelectLocations
                  name='shutOff'
                  scope={scope}
                  swtName={swtName}
                  disabled={disabled}
                  specificLocation={specificLocation}
                />
              )}
              {openMessageBox && (
                <MobileMessageBoxWrapper>
                  <InputTempMessage
                    onClose={() => setOpenMessageBox(false)}
                    title={'master control'}
                    subtitle={'m.c. off'}
                    messages={messages}
                    isMobile={isMobile}
                  />
                </MobileMessageBoxWrapper>
              )}
            </MobileWrapper>
          ) : (
            <MobileWrapper isExpanded={isExpanded} isSmall={scope !== 'switch'}>
              <SelectLocations
                name='shutOff'
                scope={scope}
                swtName={swtName}
                disabled={disabled}
                specificLocation={specificLocation}
              />
              <SectionShutOffButton>
                <ShutOffButton onClick={handleApply}>
                  <LayerB>
                    <ShutOffButtonHole>
                      <ShutOffButtonTop>deactivate</ShutOffButtonTop>
                    </ShutOffButtonHole>
                  </LayerB>
                </ShutOffButton>
              </SectionShutOffButton>
              {openMessageBox && (
                <MobileMessageBoxWrapper>
                  <InputTempMessage
                    onClose={() => setOpenMessageBox(false)}
                    title={'master control'}
                    subtitle={'m.c. off'}
                    messages={messages}
                    isMobile={isMobile}
                  />
                </MobileMessageBoxWrapper>
              )}
            </MobileWrapper>
          )}
        </>
      ) : (
        <SwitchCardWrapper $w='100%'>
          <SwitchSectionTop>
            <SwitchCardTitle>deactivate</SwitchCardTitle>

            <SelectLocations
              name='shutOff'
              scope={scope}
              swtName={swtName}
              disabled={disabled}
              specificLocation={specificLocation}
            />
          </SwitchSectionTop>

          <SwitchFormController as='div'>
            <SwitchButtonSection>
              <SwitchButtonWrapper onClick={handleApply} disabled={disabled}>
                <SwitchButtonHole disabled={disabled}>
                  <SwitchButtonTop disabled={disabled}>apply</SwitchButtonTop>
                </SwitchButtonHole>
              </SwitchButtonWrapper>
            </SwitchButtonSection>
          </SwitchFormController>
        </SwitchCardWrapper>
      )}
    </>
  );
};
export default ShutOff;

const MobileWrapper = styled.div`
  position: relative;
  ${(p) =>
    p.isSmall
      ? css`
          ${flexDirectionColumn};
          margin: 6px 0 3px 0;
        `
      : css`
          width: 314px;
          height: 72px;
          border-radius: 36px;
          ${layerC};
          ${flexBoxCenter};
          ${(p) =>
            p.isExpanded &&
            css`
              height: auto;
              border-radius: 36px;
              ${flexDirectionColumn};
              padding: 2px 0;
            `}
        `}
`;

const SectionShutOffButton = styled.section`
  width: 299px;
  height: 68px;
  border-radius: 34px;
  ${layerA180Deg};
  ${flexBoxCenter};
  margin-top: 6px;
`;
const ShutOffButton = styled.button`
  width: 288px;
  height: 58px;
  border-radius: 29px;
  ${layerA};
  ${flexBoxCenter};
`;
const LayerB = styled.div`
  width: 282px;
  height: 52px;
  border-radius: 26px;
  ${layerA180Deg};
  ${flexBoxCenter};
`;

const ShutOffButtonHole = styled.div`
  width: 267px;
  height: 36px;
  border-radius: 18px;
  ${layerA};
  ${flexBoxCenter};
`;
const ShutOffButtonTop = styled.div`
  width: 265px;
  height: 34px;
  border-radius: 17px;
  ${layerA180Deg};
  ${flexBoxCenter};

  font-size: 12px;
  letter-spacing: 1.2px;
`;

const SectionController = styled.section`
  width: 310px;
  height: 68px;
  border-radius: 34px;
  ${layerA180Deg};
  ${flexBoxCenter};

  ${(p) =>
    p.isMargin &&
    css`
      margin-bottom: 6px;
    `}
`;

const MobileHole = styled.div`
  width: 299px;
  height: 58px;
  border-radius: 29px;
  ${layerA};
  ${flexBoxCenter};
`;
const MobileTop = styled.div`
  width: 293px;
  height: 52px;
  border-radius: 26px;
  padding: 0 2px 0 7px;
  ${justifyContentSpaceBetween};
  ${layerA180Deg};
`;

const SectionCircle = styled.section`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  ${layerC}
  ${flexBoxCenter}
`;
const CircleButton = styled.button`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  ${layerA180Deg};
  ${flexBoxCenter};

  ${(p) =>
    p.isExpanded &&
    css`
      ${readyTop180Deg}
    `}
`;
const CircleHole = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  ${layerA};
  ${flexBoxCenter};
`;
const CircleTop = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  ${layerA180Deg};
  ${flexBoxCenter};

  ${(p) =>
    p.isExpanded &&
    css`
      ${readyTop180Deg}
    `}
`;

const LogoImg = styled.img`
  height: 120%;
  ${(p) =>
    p.isSm &&
    css`
      height: auto;
    `}
`;

const SectionHeatButton = styled.section`
  width: 233px;
  height: 36px;
  border-radius: 18px;

  ${layerA}
  ${flexBoxCenter}
`;
const HeatButton = styled.button`
  width: 231px;
  height: 34px;
  border-radius: 17px;

  ${layerA180Deg}
  ${flexBoxCenter}
  font-size: 10px;
  line-height: 95%;
  padding-top: 2px;
`;

const MobileMessageBoxWrapper = styled.div`
  width: auto;
  height: auto;

  ${flexBoxCenter}

  position: absolute;
  top: 50px;
  left: -32px;

  z-index: 100;
`;
